import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Button.css';

/**
 * Reusable Button Component
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  iconPosition = 'left',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  title,
  ...props
}) => {
  const getButtonClasses = () => {
    const baseClass = 'btn';
    const variantClass = `btn-${variant}`;
    const sizeClass = size !== 'medium' ? `btn-${size}` : '';
    
    return [baseClass, variantClass, sizeClass, className]
      .filter(Boolean)
      .join(' ');
  };

  const renderIcon = () => {
    if (!icon) return null;
    return <FontAwesomeIcon icon={icon} />;
  };

  const handleClick = (event) => {
    if (disabled) return;
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type={type}
      className={getButtonClasses()}
      disabled={disabled}
      onClick={handleClick}
      title={title}
      {...props}
    >
      {icon && iconPosition === 'left' && renderIcon()}
      {children}
      {icon && iconPosition === 'right' && renderIcon()}
    </button>
  );
};

export default Button;
